import { twMerge } from 'tailwind-merge'

type SharedProps = {
  hasLeftBorder?: boolean
  hasRightBorder?: boolean
  icon: React.ComponentType<{ className?: string }>
  as?: 'a' | 'button'
}

type Props =
  | (SharedProps & { as?: 'a' } & React.HTMLProps<HTMLAnchorElement>)
  | (SharedProps & { as: 'button' } & React.HTMLProps<HTMLButtonElement>)

export const SocialButton = ({
   className,
   icon: Icon,
   hasLeftBorder = false,
   hasRightBorder = false,
   as: Tag = 'a',
   ...props
}: Props) => {
  return (
    <Tag {...(props as any)}
      className={twMerge(
        'flex items-center justify-center',
        'group size-10',
        'hover:bg-primary hover:border-primary',
        className
      )}
      style={{
        borderTop: '1px solid var(--kindest-white-fog)',
        borderBottom: '1px solid var(--kindest-white-fog)',
        ...(hasLeftBorder && {
          borderLeft: '1px solid var(--kindest-white-fog)',
          borderTopLeftRadius: '0.125rem',
          borderBottomLeftRadius: '0.125rem',
        }),
        ...(hasRightBorder && {
          borderRight: '1px solid var(--kindest-white-fog)',
          borderTopRightRadius: '0.125rem',
          borderBottomRightRadius: '0.125rem',
        }),
      }}
    >
      <Icon className={'size-5 text-whiteFog group-hover:text-white'} />
    </Tag>
  )
}
